module.exports = __webpack_public_path__ + "img/PetPlayPalsBanner.70b076f6.png";